/* eslint-disable max-len */
/**
 * German translations.
 */
export default {
  ACTION: {},
  ERROR: {
    DOWNLOAD_IMAGE: 'Das Bild konnte nicht heruntergeladen werden',
    ERROR: 'Fehler'
  },
  HEADER: {
    DESCRIPTION: 'Beschreibung',
    END_DATE: 'Bis',
    ID: 'ID',
    START_DATE: 'Am',
    TITLE: 'Titel'
  },
  LABEL: {
    ACTIVES: 'Aktive Kampagnen',
    CAMPAIGNS_SIGN_OR: 'Oder',
    CAMPAIGNS_SIGN_PLUS: '+',
    COUPON: 'Coupon',
    DESCRIPTION: 'Beschreibung',
    DESIGN_REQUESTS: 'Design',
    DESIGN_REQUESTS_ACTIVES: 'Aktive Design',
    DESIGN_REQUESTS_TERMINATED: 'Fertige Designaufträge',
    DETAIL: 'Detail',
    END_DATE: 'Bis',
    FILES_TITLE: 'Kampagnen-Ressourcen',
    FILES_TITLE_DESIGN_REQUEST: 'Ressourcen für die Designanmeldung',
    FINISHED: 'Fertig',
    FINISHED_DESIGN_REQUEST: 'Fertig',
    GENERATED: 'Generiert',
    GENERIC_DESIGN: 'Generisches Design',
    ID: 'ID',
    IN_PROGRESS: 'n bearbeitung',
    NO_ROWS_CAMPAIGNS: 'keine Kampagnen',
    NO_ROWS_DESIGN_REQUESTS: 'Keine Design',
    OFFER: 'Angebot',
    PREVIOUS_LEVEL: 'Vorherige stufe',
    START_DATE: 'Am',
    STATUS: 'Status',
    TERMINATED: 'Kampagnen beendet',
    TITLE: 'Titel',
    VALUE: 'Wert'
  },
  SENTENCE: {
    ATTACHMENT_DESCRIPTION: 'Es sind (noch) keine Kampagnen-Anhänge.',
    ATTACHMENT_DESCRIPTION_DESIGN_REQUEST:
      'Keine Anhänge für diesen Designantrag (noch).',
    ATTACHMENT_TITLE: 'Keine Anhänge.'
  },
  SUCCESS: {},
  TOOLTIP: {}
};
